import { render, staticRenderFns } from "./LvDropdownSystemClass.vue?vue&type=template&id=af6ef978"
import script from "./LvDropdownSystemClass.vue?vue&type=script&lang=js"
export * from "./LvDropdownSystemClass.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports